










import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import { Tab, Tabs } from 'vant';
import * as config from './config';
import { autoOpenApp } from '@/common/ts/common';
import { appShare, wxShareInfo, isWeiXin } from '@/common/ts/common';
Vue.use(Tab).use(Tabs);
@Component({
  components: { VoteList },
})
export default class List extends Vue {
  options = config.OPTHINES;
  active = 0;
  listType: any = '平面类';
  created() {
    console.log('listsource:' + this.$route.params.dataSource);
    console.log('listsource2:' + this.$route.query.dataSource);
    console.log('listsource3:' + this.source);

    autoOpenApp();
    // 分享
    appShare({
      title: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      url: window.location.href,
      subtitle: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      subtitle: ' 首届重庆市“吃得文明”主题活动公益广告创作大赛',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  get source() {
    if (window.udid) {
      return '';
    } else if (Number(this.$route.params.dataSource) === 2) {
      return 2;
    } else if (Number(this.$route.query.dataSource) === 2) {
      return 3;
    } else if (isWeiXin()) {
      return 1;
    }
  }
}
